import { ModelBase } from '../../core/model/model-base';
import { Translation } from '../../core/model/translation';

export class LettingFeatureAdmin extends ModelBase {
  constructor(context?: any) {
    super();
    this.id = context?.id;
    this.phrase = context?.phrase ?? [];
    this.isActive = context?.isActive ?? true;
  }

  phrase: Translation[];
  isActive: boolean;

  get caption(): string {
    return this.phrase.find(x => x.cultureName === 'sv-SE')?.translationText ?? this.phrase.find(x => !!x.translationText)?.translationText ?? '';
  }

  override toString(culture?: string): string {
    return (
      this.phrase.find(x => x.cultureName === culture)?.translationText ??
      this.phrase.find(x => x.cultureName === 'sv-SE')?.translationText ??
      this.phrase.find(x => !!x.translationText)?.translationText ??
      ''
    );
  }
}
